import { render } from "./PopupSizes.vue?vue&type=template&id=704fc34a"
import script from "./PopupSizes.vue?vue&type=script&lang=js"
export * from "./PopupSizes.vue?vue&type=script&lang=js"

import "./PopupSizes.vue?vue&type=style&index=0&id=704fc34a&scope=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__